module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-black-friday-cropped.6a24cb0b.jpg";